import type { CostRow } from '../types'

// Integer cents are exact far beyond any budget (2^53 cents), so no BigInt is needed.
const cents = (v: string): number => Math.round(Number(v) * 100)
const fromCents = (c: number): string => (c / 100).toFixed(2)

export interface GroupEstimateFacts { itemCount: number; budget: string; current: string }

/** What a group estimate would spread over: the group's uncontracted items, their budget and the estimates now in force. */
export function groupEstimateFacts(rows: CostRow[], groupId: string): GroupEstimateFacts {
  const children = new Map<string, CostRow[]>()
  rows.forEach((r) => { if (r.parentId) children.set(r.parentId, [...(children.get(r.parentId) ?? []), r]) })
  let itemCount = 0
  let budget = 0
  let current = 0
  const walk = (id: string) => (children.get(id) ?? []).forEach((r) => {
    if (r.kind === 'GROUP') { walk(r.id); return }
    if (r.costBasedForecast || r.hasForecastOverride) return
    itemCount += 1
    budget += cents(r.values.revisedBudget)
    current += cents(r.values.estimate)
  })
  walk(groupId)
  return { itemCount, budget: fromCents(budget), current: fromCents(current) }
}
